import {defineRouting} from 'next-intl/routing';

export const routing = defineRouting({
  // Supported locales
  locales: ['en', 'sv'],
  defaultLocale: 'sv',
  // Don't auto-redirect based on the browser's Accept-Language header — first
  // visit should always land on the default locale (sv).
  localeDetection: false,
});